<template>
  <div class="card__container">
    <div class="card__content">
      <div v-for="(item, index) in items" :key="index" class="card__item">
        <Heading :level="3" class="card__item-title">
          {{ item.title }}
        </Heading>
        <template v-if="item.nestedItems && item.nestedItems.length">
          <Row
            v-for="(nestedItem, nestedIndex) in item.nestedItems"
            :key="nestedIndex"
            class="card__nested-item"
            :has-line="!(nestedIndex === 0)"
          >
            <template #top-left>
              <BaseText
                class="card__nested-item-label"
                :color="NebraskaColors.textSecondary"
              >
                {{ nestedItem.label }}
              </BaseText>
            </template>
            <template #top-right>
              <BaseText class="card__nested-item-value">
                {{ nestedItem.value }}
              </BaseText>
            </template>
          </Row>
        </template>
        <Row
          v-if="item.total"
          class="card__item-total"
          data-testid="card-item-total"
        >
          <template #top-left>
            <BaseText
              class="card__item-total-label"
              :color="NebraskaColors.textSecondary"
            >
              {{ item.total.label }}
            </BaseText>
          </template>
          <template #top-right>
            <BaseText class="card__item-total-value">
              {{ item.total.value }}
            </BaseText>
          </template>
        </Row>
      </div>
      <MessageFoundation
        v-if="!!statusMessage"
        class="card__status-message"
        data-testid="resume-card-status-message"
      >
        <template #description>
          {{ statusMessage }}
        </template>
      </MessageFoundation>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Heading,
  BaseText,
  Row,
  MessageFoundation
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IResumeCardItem } from './resume-card-types';

@Component({
  components: {
    Heading,
    BaseText,
    Row,
    MessageFoundation
  }
})
export default class ResumeCard extends Vue {
  @Prop({ type: Array, required: true })
  public readonly items!: IResumeCardItem[];

  @Prop({ type: String, required: false })
  public readonly statusMessage?: string;

  public readonly NebraskaColors = NebraskaColors;
}
</script>
<style lang="less" scoped>
.card {
  &__content {
    border: @size-border-x400 solid @divider-primary;
    border-radius: @size-radius-x300;
    padding: @size-spacing-x900 @size-spacing-x1400;
    .to-md({ padding: @size-spacing-x500; });
  }
  &__item {
    &:not(:first-child) {
      margin-top: @size-spacing-x800;
    }
  }
  &__item-title {
    margin-bottom: @size-spacing-x300;
  }
  &__item-total-label,
  &__item-total-value {
    .to-md({ .text-p-5() });
  }
  &__item-total-value {
    font-weight: 700;
  }
  &__status-message {
    margin-top: @size-spacing-x300;
  }
  &__nested-item-label,
  &__nested-item-value {
    .to-md({ .text-p-5() });
  }
}
</style>
